import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import chaining from '../../../core/helpers/chaining';
import { GRID_VIEW, LIST_VIEW } from '../../../core/helpers/theme-config';

@Component({
  selector: 'app-products-loader',
  templateUrl: './products-loader.component.html',
  styleUrls: ['./products-loader.component.scss']
})

export class ProductsLoaderComponent implements OnChanges {
  @Input() loading: boolean
  @Input() gridClasses: string[] = []
  @Input() viewType: string = GRID_VIEW
  @Input() productsCount = 4
  @Input() size = 'default'
  productsArray = []

  ngOnChanges(changes: SimpleChanges) {
    const productsCount = chaining(changes, 'productsCount.currentValue')

    if (productsCount)
      this.productsArray = Array(productsCount).fill(0)
  }

  get parseGridClasses(): string {
    if (Array.isArray(this.gridClasses))
      return this.gridClasses.join(' ')
  }

  get gridViewType(): boolean {
    return GRID_VIEW === this.viewType
  }

  get listViewType(): boolean {
    return LIST_VIEW === this.viewType
  }
}
